export class CardBorder {
  constructor() {
    this.isInitialized = false;
    this.cards = new Map();
    this.prefersReducedMotion = false;
  }

  init() {
    if (this.isInitialized) return;

    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.initCards();
    this.isInitialized = true;
  }

  initCards() {
    document.querySelectorAll('[data-card-border]').forEach((container, index) => {
      if (this.cards.has(container)) {
        this.destroyCard(container);
      }

      const card = new CardInstance(container, index, {
        prefersReducedMotion: this.prefersReducedMotion
      });
      this.cards.set(container, card);
    });
  }

  destroyCard(container) {
    const card = this.cards.get(container);
    if (card) {
      card.destroy();
      this.cards.delete(container);
    }
  }

  destroy() {
    this.cards.forEach((card, container) => {
      this.destroyCard(container);
    });

    this.isInitialized = false;
  }
}

class CardInstance {
  constructor(container, index, options = {}) {
    this.container = container;
    this.index = index;
    this.options = options;

    this.boundMouseMove = null;
    this.boundRecalc = null;

    this.rect = null;

    this.init();
  }

  init() {
    if (this.options.prefersReducedMotion) return;

    this.recalculateRect();
    this.setupTracking();
    this.setupResizeObserver();
  }

  recalculateRect() {
    this.rect = this.container.getBoundingClientRect();
  }

  setupResizeObserver() {
    this.boundRecalc = () => this.recalculateRect();

    window.addEventListener("resize", this.boundRecalc);
    window.addEventListener("scroll", this.boundRecalc, { passive: true });
  }

  setupTracking() {
    this.boundMouseMove = this.handleMouseMove.bind(this);
    this.container.addEventListener('mousemove', this.boundMouseMove, { passive: true });
  }

  handleMouseMove(e) {
    if (!this.rect) return;

    const posX = ((e.clientX - this.rect.left) / this.rect.width) * 100;
    const posY = ((e.clientY - this.rect.top) / this.rect.height) * 100;

    this.container.style.setProperty('--_x', Math.round(posX) + '%');
    this.container.style.setProperty('--_y', Math.round(posY) + '%');
  }

  destroy() {
    if (this.boundMouseMove) {
      this.container.removeEventListener('mousemove', this.boundMouseMove);
      this.boundMouseMove = null;
    }

    if (this.boundRecalc) {
      window.removeEventListener("resize", this.boundRecalc);
      window.removeEventListener("scroll", this.boundRecalc);
      this.boundRecalc = null;
    }

    this.container.style.removeProperty('--_x');
    this.container.style.removeProperty('--_y');
  }
}
